import { composeIO } from 'react-compose-io'
import { formularioTipoLancamentoParceiroIO } from './FormularioTipoLancamentoParceiro.IO'
import { FormularioTipoLancamentoParceiroView } from './FormularioTipoLancamentoParceiro.View'

export const FormularioTipoLancamentoParceiro = composeIO(FormularioTipoLancamentoParceiroView, formularioTipoLancamentoParceiroIO)
